import { notifierStore } from "src/framework/store/NotifierStore";

export const MENSAGEM_PENDENCIA_TROCA = "Não autorizado, existe uma edição avançada em aberto! Favor entrar em contato com o time comercial!";

export const showPendenciaTrocaComponenteAlert = () => {
  notifierStore.setNotifier({
    title: "Atenção!",
    content: MENSAGEM_PENDENCIA_TROCA,
    timeOut: 3500,
    onClose: () => {
      notifierStore.setOpen(false);
    }
  });
  notifierStore.setOpen(true);
}